/* eslint-disable @angular-eslint/no-empty-lifecycle-method */
import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Modal1Component } from './modal-1/modal-1.component';
import { CloseConfirmationComponent } from './modal-1/close-confirmation/close-confirmation.component';
import { Modal2Component } from './modal-2/modal-2.component';
import { ModalService } from '../../../../../components/modal-list/modal-list.service';

@Component({
  selector: 'demo-modal',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './demo-modal.component.html',
  styleUrl: './demo-modal.component.scss',
})
export class DemoModalComponent implements OnInit {
  constructor(private modalService: ModalService) {}

  ngOnInit(): void {
    // this.openModal();
  }

  openModal() {
    this.modalService.create({
      id: 'SimpleModal',
      title: 'Simple Modal',
      width: 500,
      component: Modal2Component,
    });
  }

  openModalCloseConfirmation() {
    this.modalService.create({
      id: 'modal-1',
      title: 'Modal 1',
      width: 1000,
      component: Modal1Component,
      onSkip: () => {
        this.modalService.create({
          id: 'modal-1-close-confirmation',
          title: 'Modal 1 - Close Confirmation',
          width: 500,
          hasCloseButton: false,
          component: CloseConfirmationComponent,
          onSkip: () => {
            return false;
          },
        });
      },
    });
  }
}
